import styled from 'styled-components';

import rem from 'polished/lib/helpers/rem';
import toColorString from 'polished/lib/color/toColorString';

import color from '@decisiv/design-tokens/lib/color';
import spacing from '@decisiv/design-tokens/lib/spacing';

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(spacing.base / 2)};
`;

export const AccountsPanel = styled.div`
  width: ${rem(590)};
  max-width: 100%;
`;

export const AccountsEmpty = styled.div`
  padding: ${rem(spacing.base)};
`;

export const AccountsStatus = styled.div`
  padding: ${rem(spacing.base / 2)} ${rem(spacing.base)};
  border-top: 1px solid ${toColorString(color.opacity.charcoal15)};
`;

export const AccountsTrigger = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${rem(spacing.base / 2)};
  width: 100%;
  box-sizing: border-box;
  min-height: ${rem(50)};
  /* InputInnerContainer's 6px/10px, and IconContainer's 16px beside the chevron. */
  padding: ${rem(6)} ${rem(spacing.base * 0.8)} ${rem(spacing.base / 2)}
    ${rem(spacing.base / 2)};
  text-align: left;
  cursor: text;
  background: ${toColorString(color.base.snowWhite)};
  border: 1px solid
    ${({ $active }) =>
      toColorString(
        $active ? color.interaction.pacificOcean : color.base.quarterMoon,
      )};
  color: ${toColorString(color.base.charcoal)};

  &:hover {
    border-color: ${toColorString(color.interaction.indianOcean)};
  }
`;

export const AccountsInput = styled.input`
  flex: 1;
  min-width: ${rem(180)};
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: ${toColorString(color.base.charcoal)};
  font: inherit;

  &::placeholder {
    color: ${toColorString(color.base.alaskanHusky)};
  }
`;

export const AccountsChevron = styled.button`
  display: flex;
  align-items: center;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  color: ${toColorString(color.base.alaskanHusky)};
`;

export const AccountsTriggerBody = styled.span`
  display: flex;
  flex-direction: column;
  gap: ${rem(spacing.base / 4)};
  flex: 1;
  min-width: 0;
`;

export const AccountsTags = styled.span`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${rem(spacing.base / 4)};
  width: 100%;
  min-width: 0;
`;

export const AccountsLabel = styled.span`
  display: flex;
  align-items: center;
  gap: ${rem(spacing.base / 4)};
`;
